import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { EyeIcon, EyeOffIcon } from 'lucide-react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import routeConfig from '@/config/routeConfig';
import { PIN_REQUIRED_LENGTH } from '@/use-cases/set-pin';
import styles from './pin-sign-input.module.scss';

type PinSignInputProps = {
	value: string;
	setValue: (newValue: string) => void;
	disabled?: boolean;
	/** Rendered when the signing request failed, next to the setup link. */
	autoFocus?: boolean;
};

export const PinSignInput: React.FC<PinSignInputProps> = ({
	value,
	setValue,
	disabled = false,
	autoFocus = false,
}) => {
	const [isVisible, setIsVisible] = useState(false);

	return (
		<div className={styles['pin-sign-input']}>
			<Label htmlFor="signing-pin-input">Ingresa tu PIN de firma</Label>
			<div className={styles['input-with-toggle']}>
				<Input
					id="signing-pin-input"
					type={isVisible ? 'text' : 'password'}
					autoComplete="off"
					autoFocus={autoFocus}
					disabled={disabled}
					maxLength={PIN_REQUIRED_LENGTH}
					placeholder="Tu PIN de firma"
					value={value}
					onChange={(event) =>
						setValue(event.target.value.slice(0, PIN_REQUIRED_LENGTH))
					}
				/>
				<button
					type="button"
					className={styles.toggle}
					onClick={() => setIsVisible((visible) => !visible)}
					aria-label={isVisible ? 'Ocultar PIN' : 'Mostrar PIN'}
					aria-pressed={isVisible}
					disabled={disabled}
				>
					{isVisible ? <EyeOffIcon size={18} /> : <EyeIcon size={18} />}
				</button>
			</div>
			<p className={styles.hint}>
				Recuerda diferenciar entre mayúsculas y minúsculas.{' '}
				<Link to={routeConfig.pinSetup} className={styles.link}>
					¿No tienes PIN?
				</Link>
			</p>
		</div>
	);
};
